/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPRegionsEnum } from './gCPRegionsEnum';


export interface CreateGcpBucketRequest { 
    /**
     * Bucket Name
     */
    bucket_name: string;
    region_id: GCPRegionsEnum;
}
export namespace CreateGcpBucketRequest {
}


